<template>
	<div>
		<Bj :bjData="bjData" />
		<div>
			<div class="mobileTitle">高考日语的政策背景</div>
			<div class="mobileMiniTitle">大学入試における日本語の政策背景</div>
			<div class="introduceBox">
				<div class="introduce">
					<img src="../../assets/pc/gaokao/bjimg1.png" alt="" />
					<div>
						99%的学生和家长都误以为，高考
						外语等于“英语”，或误以为高考外
						语只能考英语，实际上高考的“语
						数外”中的“外”还可选其他语言。
					</div>
				</div>
				<div class="introduce">
					<img src="../../assets/pc/gaokao/bjimg2.png" alt="" />
					<div>
						教育部明文规定，高考外语科目分
						为：英语、日语、俄语、德语、法
						语、西班牙语共六种语言，考生可
						自由选择其中一门参加高考。
					</div>
				</div>
				<div class="introduce">
					<img src="../../assets/pc/gaokao/bjimg3.png" alt="" />
					<div>
						可选的六门高考语言满分均为150
						分，均不折扣计入高考总分成绩。
						同时教育部【2003/6号】文件批
						示，鼓励有条件的学校开设两种 或以上语言课程。
					</div>
				</div>
				<div class="introduce">
					<img src="../../assets/pc/gaokao/bjimg4.png" alt="" />
					<div>
						其中日语特别有优势，因为日语是
						中文演变而来的，其中有一半是汉
						字，因此作为中国学生，日语是一
						门相对简单易学，容易考取高分的 外语。
					</div>
				</div>
			</div>
			<div class="mobileTitle">选择日语参加高考的优势</div>
			<div class="mobileMiniTitle">
				大学入試で日本語を選択するメリット
			</div>
			<div class="advantage">
				<img src="../../assets/mobile/gaokao/advantage1.png" alt="" />
				<img src="../../assets/mobile/gaokao/advantage2.png" alt="" />
				<img src="../../assets/mobile/gaokao/advantage3.png" alt="" />
				<img src="../../assets/mobile/gaokao/advantage4.png" alt="" />
			</div>
			<div class="mobileTitle">日语高考常见问题</div>
			<div class="mobileMiniTitle">日本語の大学入試問題</div>
			<div class="questionBox">
				<div v-for="(item, i) in questionList" :key="i">
					<div class="mediate question">
						<img src="../../assets/pc/gaokao/Q.png" alt="" />
						<span>{{ item.question }}</span>
					</div>
					<div class="answer">
						<img src="../../assets/pc/gaokao/A.png" alt="" />
						<div v-html="item.answer"></div>
					</div>
				</div>
			</div>
			<div class="mobileTitle">日语高考VS英语高考</div>
			<div class="mobileMiniTitle">日本語VS英語</div>
			<img
				class="form"
				src="../../assets/mobile/gaokao/form1.png"
				alt=""
			/>
			<img
				class="form"
				src="../../assets/mobile/gaokao/form2.png"
				alt=""
			/>
			<div class="mobileTitle">高考日语各地开班情况</div>
			<div class="text-container">
				<transition class="inner-container2" name="slide" mode="out-in">
					<p class="mobileMiniTitle" :key="text.id">
						姓名:{{ text.val.name }} &nbsp;&nbsp;日语成绩:{{
							text.val.riYuScore
						}}分 &nbsp;&nbsp; 入班时英语成绩:{{
							text.val.english
						}}分 &nbsp;&nbsp; 提分:{{ text.val.promote }}分
						&nbsp;&nbsp;
						{{ text.val.branch }}
					</p>
				</transition>
			</div>
		</div>
		<Banner />
	</div>
</template>

<script>
import { studentList } from '@/utils/studentList'
import Bj from '@/components/mobile/bj'
import Banner from '@/components/mobile/banner'
export default {
	components: {
		Bj,
		Banner,
	},
	data() {
		return {
			times: {},
			arr: [
				{
					name: '沈*',
					riyuScore: '127',
					english: '66',
					promote: '61',
					branch: '文科',
				},
				{
					name: '沈*',
					riyuScore: '127',
					english: '66',
					promote: '61',
					branch: '文科',
				},
			],
			number: 0,
			bjData: {
				imgUrl: 'https://qn.juquedu.com/%E7%BB%84%2063%402x.png',
				title: '高考日语介绍',
				minTitle: '政策背景、高考优势、常见问题、开班情况',
			},
			questionList: [
				{
					question: '学习日语的优势有哪些？',
					answer: `（1）日语的文字起源于汉语。日文中的汉字词汇大部分跟中文写法及语义完全相同，没学过日语也能猜出意思，相较英语来说具有极大的优势。<br/>
							    （2）高考英语的词汇要求是4500个左右；而日语的要求是2200个单词左右，并且只有220个高考语法点。<br/>
							    （3）日语试卷是全国卷（上海除外），难度偏低。题型只有单选题（120分）和作文（30分），没有英语考试中出现的完形填空，改错题等题型。<br/>
							    （4）考试人数少，每年全国超过一千万人参加高考，用日语参考的人数不足百分之一，因此竞争压力小。`,
				},
				{
					question: '什么样的学生适合用日语代替英语参加高考?',
					answer: `（1）利用日语冲击985/211名校的学生，这类学生英语基础不是特别差，但很难突破到100分以上。通过学习日语，可以在高考中外语成绩突破120-140分。<br/>
                    （2）二本冲击一本，专科冲击本科的学生，英语成绩长期达不到90分的学生。本身基础不稳固，很难通过3年学习达到理想分数，通过日语高考，轻松突破100分，提高一个升学档次。<br/>
                    （3）艺术以及体育类学生，这类学生平时需要学习音乐，美术，体育等专业课程，时间精力有限。可能专业成绩优秀，但文化科目薄弱，选择日语可以达到迅速提分的目的。<br/>
                    （4）对日语感兴趣，想出国留学的学生，申请日本高校日语能力需达到N1或N2水平，在高中选择日语学习，为留学抢占先机。`,
				},
				{
					question:
						'怎么上课？会不会占用太多的学习时间，导致其他功能停滞？',
					answer: `（1）完全不影响学生们的其它科目的课程，只需在英语课（或者自习课）时，选择日语高考课程的同学到日语专用教室上日语课即可。<br/>
                    （2）日语老师常驻校内，教学并指导学生学习。<br/>
                    （3）选择日语的同年级学生组成日语班，课程设置与教学和其他班级相同，只是把传统意义上的英语课用日语课替代。`,
				},
				{
					question:
						'从没听说过日语高考，我们这里的考试能考日语吗？什么时候报考？',
					answer: `  中国大陆高考外语科目可以自由选择6门语种进行高考，享有同等考试待遇，在填写高考考试报名报名表时，将考试语种选择为“日语”即可，
                    高三上学期（十一月上旬左右）报考，日语高考卷是全国统一命（上海除外），总分150分。`,
				},
				{
					question:
						'高考日语对专业选择有无影响？有哪些高校不接受日语考生？',
					answer: `《教育部关于做好普通高校招生工作的通知》明文规定除军事、国防和公共安全等部分特殊院校（专业）外，高校不得规定男女生录取比例，高校
                  不得对报考非外国语言文学类的考生做统考外语语种限制。
                  所有中国高校不得对考生的高考外语语种做出限制。由考生进行自由选择。除外国语言文学类专业可以做出相应的限制（主要体现在可能需要全
                  英语教学，或者使用英语教材的专业，比如“商务英语”等专业），毕竟这类专业是需要学生有一定语言基础的。不过，对于想要靠日语参加高考
                  的同学来说，这类专业估计也不会在备选之列。所以，根本不需要担心影响报考院校和专业的问题。填报志愿前，日语任课教师会一一指导学生，
                  保证志愿有效性。`,
				},
				{
					question:
						'大学还需要学英语吗？没有英语四级能不能毕业？要是想考研的话没有英语成绩怎么办？',
					answer: `  部分高校公共必修课需要提供英语四级证书，同样的日语也有公共日语四级证书，同样受高校认可，并且考日语其主要目的是为了能够在高考时
              加分，从而进入一个更理想的大学。同时考研也是可以用日语参考的，并且难度也会比英语简单很多。`,
				},
			],
		}
	},
	computed: {
		text() {
			return {
				id: this.number,
				val: studentList[this.number],
			}
		},
	},
	created() {
		// console.log(studentList)
		this.startMove()
	},
	methods: {
		startMove() {
			this.times = setTimeout(() => {
				if (this.number === studentList.length) {
					this.number = 0
				} else {
					this.number += 1
				}
				this.startMove()
			}, 2000)
		},
	},
	beforeDestroy() {
		clearTimeout(this.times)
	},
}
</script>

<style lang="scss" scoped>
.introduceBox {
	padding: 0 15px;
	box-sizing: border-box;
	display: flex;
	justify-content: space-between;
	margin-top: 24px;
	flex-wrap: wrap;
	.introduce {
		width: 168px;
		font-size: 14px;
		color: #333333;
		line-height: 24px;
		img {
			width: 168px;
			margin-bottom: 8px;
		}
	}
}
.advantage {
	padding: 0 15px;
	box-sizing: border-box;
	margin-top: 24px;
	img {
		margin-top: 24px;
		width: 100%;
	}
}
.questionBox {
	padding: 0 15px;
	box-sizing: border-box;
	font-size: 18px;
	img {
		width: 40px;
		height: 40px;
		margin-right: 10px;
	}
	.question {
		color: #333333;
		font-weight: 800;
		margin-bottom: 16px;
		margin-top: 30px;
	}
	.answer {
		font-size: 14px;
		color: #5f6464;
		display: flex;
		align-content: flex-start;
		padding-bottom: 30px;
		border-bottom: 1px solid #efefef;
	}
}
.form {
	padding: 0 15px;
	box-sizing: border-box;
	margin-top: 26px;
	width: 100%;
}

.userImage {
	overflow: hidden;
	.userImageAllWrapper {
		background-color: yellowgreen;
		width: 1160px;
		list-style: none;
		display: flex;
		flex-wrap: wrap;
		&:last-child {
			margin-left: -40px;
		}
	}
}
.text-container {
	margin-top: 10px;
	height: 40px;
	overflow: hidden;
	display: flex;
	justify-content: center;
	box-sizing: border-box;
	padding: 0 40px;
	align-items: center;
	.slide-enter-active,
	.slide-leave-active {
		transition: all 0.5s linear;
	}
	.slide-leave-to {
		transform: translateY(-30px);
	}
	.slide-enter {
		transform: translateY(20px);
	}
}
</style>
